// extracted by mini-css-extract-plugin
export default {"cta":"RouteRepayment_cta__Opdto","ctaText":"RouteRepayment_ctaText__zt03f"};